import { EntityRepository, Repository } from "typeorm";
import { CodeListMainItems } from "../code-list-main-items.entity";

@EntityRepository(CodeListMainItems)
export class CodeListMainItemsRepository extends Repository<CodeListMainItems> {

}